/**
 * In-memory wipe of sensitive JS carriers.
 *
 * Best-effort only: the JS engine may have already copied the buffer (GC,
 * string interning). It cannot reach libsodium's WASM heap (opaque) — that is
 * the engine's responsibility. We overwrite with random bytes first (defeats a
 * "zeroed region == was-secret" heuristic) then zero-fill.
 */
import { randomBytes } from './random.js';
/** Overwrite `buf` with random bytes, then zero it. No-op on empty buffers. */
export function wipe(buf) {
    if (buf.length === 0) {
        return;
    }
    buf.set(randomBytes(buf.length));
    buf.fill(0);
}
//# sourceMappingURL=memory.js.map